    <div class="dashboard">
      <h1 class="dashboard-title">Панель управления</h1>

      <div class="stats-grid" *ngIf="!loading; else spinner">
        <mat-card class="stat-card" routerLink="/bookings" fragment="new">
          <mat-card-content class="stat-content stat-new">
            <div class="stat-number">{{ newBookings }}</div>
            <div class="stat-label">Новых бронирований</div>
            <mat-icon class="stat-icon">event_available</mat-icon>
          </mat-card-content>
        </mat-card>

        <mat-card class="stat-card" routerLink="/bookings" fragment="confirmed">
          <mat-card-content class="stat-content stat-confirmed">
            <div class="stat-number">{{ confirmedBookings }}</div>
            <div class="stat-label">Подтверждённых</div>
            <mat-icon class="stat-icon">check_circle</mat-icon>
          </mat-card-content>
        </mat-card>

        <mat-card class="stat-card" routerLink="/rentals" fragment="issued">
          <mat-card-content class="stat-content stat-issued">
            <div class="stat-number">{{ issuedRentals }}</div>
            <div class="stat-label">Выдано в прокате</div>
            <mat-icon class="stat-icon">car_rental</mat-icon>
          </mat-card-content>
        </mat-card>

        <mat-card class="stat-card stat-card__free" routerLink="/cars">
          <mat-card-content class="stat-content stat-free">
            <div class="stat-number">{{ freeCars }}</div>
            <div class="stat-label">Свободных авто</div>
            <mat-icon class="stat-icon">directions_car</mat-icon>
          </mat-card-content>
        </mat-card>

      </div>

      <ng-template #spinner>
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </ng-template>

      <div class="quick-actions" *ngIf="!loading">
        <h2 class="section-title">Быстрые действия</h2>
        <div class="actions-grid">
          <button mat-raised-button color="primary" routerLink="/bookings/new">
            <mat-icon>add</mat-icon>
            Новое бронирование
          </button>
          <button mat-stroked-button color="accent" routerLink="/rentals/new">
            <mat-icon>car_rental</mat-icon>
            Новый прокат
          </button>
          <button mat-stroked-button routerLink="/clients/new">
            <mat-icon>person_add</mat-icon>
            Новый клиент
          </button>
          <button mat-stroked-button routerLink="/cars">
            <mat-icon>directions_car</mat-icon>
            Доступность авто
          </button>
        </div>
      </div>
    </div>
  
